export enum UserRoleType {
  ADMIN = "admin",
  PROVIDER = "provider",
}

export enum AccountStatus {
  NEEDS_VERIFICATION = "needs_verification",
  VERIFIED = "verified",
  NEEDS_PASSWORD_RESET = "needs_password_reset",
  NEEDS_PASSWORD_UPDATE = "needs_password_update",
  TEMPORARY_PASSWORD = "temp_password",
  PENDING_FIRST_LOGIN = "pending_first_login",
}

export interface CurrentUser {
  id: string;
  email: string;
  firstName?: string;
  lastName?: string;
  address?: string;
  phone?: string;
  role?: UserRoleType;
  providerId?: string;
  updatedAt?: Date;
  createdAt?: Date;
  mfaEnabled?: boolean;
  isAvailable?: boolean;
  accountStatus?: AccountStatus;
  stripeAccountId?: string;
  cometChatId?: string;
  smsNotifications?: boolean;
}

export interface AuthUser {
  id?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  address?: string;
  phone?: string;
  role?: UserRoleType;
  providerId?: string;
  updatedAt?: Date;
  createdAt?: Date;
  mfaEnabled?: boolean;
  isAvailable?: boolean;
  password?: string;
  accountStatus?: AccountStatus;
  accessToken?: string;
}
